import { store } from "../../../../../store/store";

// Método para guardar el Log cuando se notifica a FONASA
export const enviarLogDoctorNotifyEmision = (
    action,
    profDNI,
    profName,
    patientDNI,
    patientName,
    patientLastName,
    responseFonasa,
    IP
) => {
    const reduxState = store.getState().company;
    const db = reduxState?.companyInstance?.db;

    // Se crea la fecha actual en la que se crea el Log
    let date = new Date();

    // Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
    db.collection("logFonasa")
        .doc("issue")
        .collection("added")
        .add({
            log_date: date,
            action: action,
            professionalDNI: profDNI,
            professional: profName,
            patientDNI,
            patient: `${patientName} ${patientLastName ?? ""}`.trim(),
            glosaRespuesta: responseFonasa.glosaRespuesta,
            operacionID: responseFonasa.operacionID,
            timestamp: responseFonasa.timestamp,
            ip: IP.IPv4,
            country: IP.country_name,
        });
};

// Método para guardar el Log cuando se notifica a FONASA
export const enviarLogDoctorErrorNotifyEmision = (
    action,
    error,
    profDNI,
    profName,
    patientDNI,
    patientName,
    patientLastName,
    IP,
    folio
) => {
    const reduxState = store.getState().company;
    const db = reduxState?.companyInstance?.db;

    // Se crea la fecha actual en la que se crea el Log
    let date = new Date();

    // Se registra en la colección el Log, almacenando la fecha de la acción, la acción y el UID de la persona que la originó
    db.collection("logFonasa")
        .doc("issue")
        .collection("error")
        .add({
            log_date: date,
            action: action,
            professionalDNI: profDNI,
            professional: profName,
            patientDNI,
            patient: `${patientName} ${patientLastName ?? ""}`.trim(),
            codigoRespuesta: error.codigoRespuesta,
            glosaRespuesta: error.glosaRespuesta,
            operacionID: error.operacionID,
            timestamp: error.timestamp,
            ip: IP.IPv4,
            country: IP.country_name,
            folio
        });
};